export enum allergyCategoryEnum {
    'allergy' = 1,
    'intolerance' = 2,
    'aversion' = 3,
    'immune' = 4,
}
